import 'uni-pages';
import Vue from 'vue'
import Page from './demo/pages/mall/orderPaySuccess.vue'
createPage(Page)